import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './MonthDayPicker.css';

const MonthDayPicker = ({
  label,
  selectedDate,
  onChange,
  isRequired = false,
  error,
  name
}) => {
  const datePickerRef = useRef(null);

  const handleCalendarIconClick = (e) => {
    e.stopPropagation();
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  return (
    <div className="month-day-picker-container">
      <DatePicker
        ref={datePickerRef}
        selected={selectedDate}
        onChange={onChange}
        dateFormat="MMMM d"
        placeholderText=""
        className={`input-box fts-14 common-text ftw-4 ${error ? 'input-error' : ''}`}
        wrapperClassName="month-day-wrapper"
        name={name}
        autoComplete="off"
        renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
          <div className="month-picker-custom-header">
            <button type="button" onClick={decreaseMonth} className="month-nav-btn">‹</button>
            <span className="month-picker-title">
              {date.toLocaleDateString('en-US', { month: 'long' })}
            </span>
            <button type="button" onClick={increaseMonth} className="month-nav-btn">›</button>
          </div>
        )}
      />
      <label className={`input-label fts-14 common-text ftw-4 ${selectedDate ? 'has-value' : ''}`}>
        {label} {isRequired && <span style={{ color: '#EF4444' }}>*</span>}
      </label>
      <div className="month-day-calendar-icon" onClick={handleCalendarIconClick}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      </div>
      {error && (
        <div className="input-error-message fts-12" style={{ color: '#EF4444', marginTop: '2px' }}>
          {Array.isArray(error) ? error[0] : error}
        </div>
      )}
    </div>
  );
};

export default MonthDayPicker;
